import React from 'react';

import Card from '../../Card';
import Grid from '../../Grid';
import { Typography } from '../../Typography';

interface Props {
  title: string;
}

const Section: React.FC<Props> = ({ title, children }) => (
  <Grid item xs={12} sm={10} md={6}>
    <Card>
      <Grid container spacing={4} style={{ padding: '30px' }}>
        <Grid item xs={12}>
          <Typography.H3>{title}</Typography.H3>
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Card>
  </Grid>
);

export default Section;
